import { render, staticRenderFns } from "./DrProject.vue?vue&type=template&id=441c6c38&scoped=true"
import script from "./DrProject.vue?vue&type=script&lang=js"
export * from "./DrProject.vue?vue&type=script&lang=js"
import style0 from "./DrProject.vue?vue&type=style&index=0&id=441c6c38&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c6c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441c6c38')) {
      api.createRecord('441c6c38', component.options)
    } else {
      api.reload('441c6c38', component.options)
    }
    module.hot.accept("./DrProject.vue?vue&type=template&id=441c6c38&scoped=true", function () {
      api.rerender('441c6c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/drProject/DrProject.vue"
export default component.exports